import { GenericServiceRequest } from './generic-service-request';
import { AutoCompleteModelOptions } from '../domain-models/autocomplete/auto-complete-options';
import type { AutoCompleteModelRequestInterface } from '@nts/std/interfaces';

export class AutoCompleteModelRequest extends GenericServiceRequest<AutoCompleteModelOptions> implements AutoCompleteModelRequestInterface {

}
